import { graphql } from 'gql';

export const bimWorkOrderChangeGql = graphql(`
    query bimWorkOrderChange($workOrderChangeId: Long!) {
        bimWorkOrderChange(workOrderChangeId: $workOrderChangeId) {
            data {
                authoredBy
                comment
                createdAt
                id
                internalNumber
                signingDate
                status
                statusFollowers
                subject
                updatedAt
                workOrderId
                seasons {
                    id
                    workOrderSeason {
                        year
                    }
                }
                seasonDistributions {
                    workOrderChangeSeasonId
                    seasonValue
                }
            }
        }
    }
`);

export const bimWorkOrderChangeTotals = graphql(`
    query bimWorkOrderChangeTotals(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int
        $chapter: BimChapterEnum
        $workOrderObjectId: Long
        $workOrderChangeObjectId: Long
        $useInPrices: Boolean!
        $priceLevel: BimPriceLevelEnum
        $where: BimWorkOrderChangeTotalItemDataFilterInput
        $order: [BimWorkOrderChangeTotalItemDataSortInput!]
    ) {
        bimWorkOrderChangeTotals(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            chapter: $chapter
            workOrderObjectId: $workOrderObjectId
            workOrderChangeObjectId: $workOrderChangeObjectId
            useInPrices: $useInPrices
            priceLevel: $priceLevel
            where: $where
            order: $order
        ) {
            items {
                name
                quantity
                sortOrder
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                    nr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
            }

            totalCount
        }
    }
`);
